class MobileAppBar extends HTMLElement {
  connectedCallback() {
    this.menuTrigger = this.querySelector('[data-mobile-menu-trigger]');
    this.cartTrigger = this.querySelector('[data-mobile-cart-trigger]');
    this.cartCount = this.querySelector('[data-mobile-cart-count]');

    this.menuTrigger?.addEventListener('click', this.openMenu);
    this.cartTrigger?.addEventListener('click', this.openCart);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      this.cartUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
        if (typeof cartData?.item_count === 'number') this.updateCartCount(cartData.item_count);
      });
    }
  }

  disconnectedCallback() {
    this.menuTrigger?.removeEventListener('click', this.openMenu);
    this.cartTrigger?.removeEventListener('click', this.openCart);
    this.cartUnsubscriber?.();
  }

  openMenu = () => {
    const editorialMenu = document.querySelector('.editorial-site-header__menu > summary');
    const dawnMenu = document.querySelector('#Details-menu-drawer-container > summary');
    (editorialMenu || dawnMenu)?.click();
  };

  openCart = (event) => {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    event.preventDefault();
    drawer.open(this.cartTrigger);
  };

  updateCartCount(count) {
    if (!this.cartCount) return;
    this.cartCount.textContent = count;
    this.cartCount.classList.toggle('is-empty', count === 0);
  }
}

if (!customElements.get('mobile-app-bar')) {
  customElements.define('mobile-app-bar', MobileAppBar);
}
